import { Navbar, Footer } from "../adminComponents";
import  {useNavigate}  from "react-router-dom";
import axios from "axios";
import configData from "../config.json";
import {React,useState,useEffect} from "react";

function AdminLogin() {

    const [inputData,setInputData]=useState([]);
    const navigate=useNavigate();

    useEffect(() => { 
        localStorage.removeItem('eshopBranchID');
        
    }, []);

    const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});    
    }

    const handleSubmit=async(e)=>{
        e.preventDefault();
        let res=await axios.post(configData.SERVER_ADMIN_URL+'/signin',inputData);
        if(res.status===200){

                if(res.data.isUser){
                    
                    localStorage.setItem('eshopBranchID', res.data.data.BranchID);
                    
                    window.location.replace('/admin');
                } else{
                    alert('wrong Email/password');
                }
        } else {
           alert('System Error');     
        }
            
    }

  return (
    <>
        <Navbar />
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
        <div className="col-lg-4 col-md-6 col-sm-8">
        <div className="card shadow-lg border-0">
      
            <div className="card-header text-center bg-info text-white">
                <h5 className="mb-0">Admin Login</h5>
            </div>

            <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input 
                type="email" 
                className="form-control" 
                name="emailId" 
                id="emailId"
                placeholder="Enter your email"
                value={inputData.emailId}
                onChange={(e)=>{handleInput(e)}}
                />
                </div>

                <div className="mb-3">
                <label className="form-label">Password</label>
                <input 
                type="password" 
                className="form-control" 
                name="password" 
                id="password"
                placeholder="Enter your password"
                value={inputData.password}
                onChange={(e)=>{handleInput(e)}}
                />
                </div>

                <div className="d-grid">
                <button className="btn btn-info">Login</button>
                </div>
                </form>
            </div>

            <div className="card-footer text-center small">
                © 2026 Bangladesh Steel and Engineering Corporation
            </div>

        </div>
        </div>
        </div>
    <Footer />
    </>
  )
}

export default AdminLogin